module.exports = __webpack_public_path__ + "media/applicants/yogurt1-02217515.png";